import { render, staticRenderFns } from "./confirmRegInfo.vue?vue&type=template&id=36e9cabe&"
import script from "@viewJs/examRegisteation/confirmRegInfo.js?vue&type=script&lang=js&"
export * from "@viewJs/examRegisteation/confirmRegInfo.js?vue&type=script&lang=js&"
import style0 from "./confirmRegInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports